import React, { Fragment, useState } from "react";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import TextField from "@mui/material/TextField";
import { Box, styled } from "@mui/material";

const TextInput = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
  },
  display: "block",
  fontFeatureSettings: `'pnum' on, 'lnum' on`,
  disableUnderline: true, 
}));

const InputData = ({ label, type, onChange, error, helperText, autoFocus, placeHolder, onKeyPress }) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  return (
    <Fragment>
      {type ? (
        <Box >
          <TextInput
            fullWidth={true}
            error={error}
            helperText={helperText}
            size="small"
            autoFocus={autoFocus}
            onChange={(e) => onChange(e.target.value)}
            InputProps={{
              style: {
                fontSize: "16px",
                textOverflow: "ellipsis"
              },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility sx={{color : "#263057"}} /> : <VisibilityOff   sx={{color : "#263057"}} />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            placeholder={placeHolder ? placeHolder : "Escribí tu contraseña"}
            type={showPassword ? "text" : "password"}
          />
        </Box>
      ) : (
        <Box>
          <TextInput
            fullWidth={true}
            error={error}
            helperText={helperText}
            size="small"
            onKeyPress={onKeyPress}
            onChange={(e) => onChange(e.target.value)}
            autoFocus={autoFocus}
            placeholder={ placeHolder ? placeHolder : "Escribí tu mail o número de suscriptor"}
            inputProps={{
              style: {
                fontSize: "16px",
                textOverflow: "ellipsis"
              }
            }}
          />
        </Box>
      )}
    </Fragment>
  );
};

export default InputData;
